module.exports = __webpack_public_path__ + "media/images/emoticons/game-050a7de65052c2d7278796ae0cdcce24.gif";